import { UIField } from "../../../models/UIField";

export const NumberField = ({ model, readonly, maxChars }: { model: UIField; readonly?: boolean; maxChars?: number }) => {
  return (
    <div className="flex h-7 items-center">
      <label title={model.description}>{model.label}</label>
      <input
        type="number"
        className={`h-full ml-auto px-2 rounded border-2 ${!readonly ? "text-black" : "bg-transparent text-white"} ${model.label ? "w-3/5" : "w-full"}`}
        readOnly={readonly}
        value={model.value}
        onInput={(e) => {
          const text = e.currentTarget.value;
          model.setValue(maxChars ? text.substring(0, maxChars) : text);
        }}
      />
    </div>
  );
};
